export default __webpack_public_path__ + "static/instagram-be6a907969188fda1439456256072b30.png";